import { React } from "react";
import { setPaymentStatus } from "../../apis/firestoreDatabase";
import "../../styles/VerifierCard.css";
import { getPaymentFileURL } from "../../apis/firebasecloud";
import { paymentStatuses } from "../../data/constants";

const openScreenshot = async ({ owner, id, setLoaderState, loadCompleteCallbackRef }) => {
  setLoaderState("block");
  try {
    window.open(await getPaymentFileURL(owner, id), '_blank');
  }
  catch (e) {
    loadCompleteCallbackRef.current = () => { alert(`Could not fetch payment screenshot: ${e}`) }
  }
  setLoaderState("none");
}

export default function Card(props) {

  return (
    <div>
      <div
        className="main_card_container"
        style={{
          backgroundColor: props.color,
          padding: "2px",
        }}
      >
        <div className="verifier_valueContainer" style={{
          marginLeft: '-4%'
        }}>
          <h2 className="verifier_card_heading">{props.name}</h2>
        </div>
        <div className="verifier_valueContainer" style={{
          
        }}>
          <h2 className="verifier_card_heading">{props.prn}</h2>
        </div>
        <div className="verifier_valueContainer" style={{
        }}>
          <h2 className="verifier_card_heading">{props.paymentStatus}</h2>
        </div>
        <div className="verifier_valueContainer" style={{
        }}>
          <h2 className="verifier_card_heading">{props.queryDate}</h2>
        </div>
        <div className="verifier_valueContainer" style={{
          padding: '0.5% 0.5% 0.5% 1.5%',
          width: '11.5%',
          backgroundColor: '#316EBC',
          fontWeight: '400',
          marginLeft: '0%',
          marginRight: '4.5%',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: 'white',
          borderRadius: '3px',
          paddingLeft: '1%',
          cursor: "pointer",
        }}
          onClick={() => openScreenshot(props)}
        >
          <a className="link-primary_linkViewDocument ViewDocumentButton" variant="primary"
            style={{
              textDecoration: "none",
              color: "white",
            }}>
            View Screenshot
          </a>
        </div>

        <div className="verify-btn" style={{
          padding: '0.5% 0.5% 0.5% 1.5%',
          width: '4%',
          backgroundColor: '#198754',
          fontWeight: '400',
          marginLeft: '0%',
          marginRight: '-7.5%',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: 'white',
          borderRadius: '3px',
          paddingLeft: '1%',
          cursor: 'pointer',
        }}
          onClick={() => setPaymentStatus(props.id, paymentStatuses.PAID)}
        >
          <a
            style={{
              textDecoration: "none",
              color: "white",
              cursor: "pointer",
            }}>
            Yes
          </a>
        </div>
        <div className="verify-btn" style={{
          padding: '0.5% 0.5% 0.5% 1.5%',
          width: '4%',
          backgroundColor: '#dc3545',
          fontWeight: '400',
          marginLeft: '2%',
          marginRight: '-2%',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: 'white',
          borderRadius: '3px',
          paddingLeft: '1%',
          cursor: 'pointer',
        }}
          onClick={() => setPaymentStatus(props.id, paymentStatuses.UNPAID)}
        >
          <a
            style={{
              textDecoration: "none",
              color: "white",
              cursor: "pointer",
            }}>
            No
          </a>
        </div>

      </div>
    </div>
  );
}
